import { auth } from "../firebase";

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const apiRequest = async (endpoint, options = {}) => {
  const user = auth.currentUser;
  const token = user ? await user.getIdToken() : null;
  
  const headers = {
    ...options.headers,
  };
  
  // Nie ustawiamy Content-Type dla FormData (multipart/form-data)
  if (!(options.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  try {
    // 🔧 POPRAWA: dodaj /api/ przed endpointem
    const url = `${API_URL}/api${endpoint}`;
    console.log('📡 API Request:', url); // Dodaj log dla debugowania
    
    const response = await fetch(url, {
      ...options,
      headers,
    });
    
    if (response.status === 401) {
      // Token nieważny - wyloguj użytkownika
      await auth.signOut();
      window.location.href = '/login';
      throw new Error('Sesja wygasła');
    }
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Błąd zapytania');
    }
    
    return await response.json();
  } catch (error) {
    console.error('❌ Błąd API:', error);
    throw error;
  }
};